import { AppealStatus, AppealType } from '@repo/types';

export type EditModalChoice =
  | 'EditAppealModal'
  | 'MarkToBeAppealedModal'
  | 'MarkPartialWriteOffModal'
  | 'MarkAppealApprovedModal';

/**
 * Single source of truth for which Edit modal renders given `(status, appealType)`.
 *
 * - `EditAppealModal`: narrow appeal-submitted modal — APPEAL_SUBMITTED + SUBSEQUENT only.
 * - `MarkPartialWriteOffModal`: narrow discount modal — NO_APPEAL and DEADLINE_EXPIRED.
 * - `MarkAppealApprovedModal`: approved-figures modal — APPEAL_APPROVED.
 * - `MarkToBeAppealedModal`: wide modal — TBA, AAS, APPEAL_SUBMITTED+BACKLOG, and the default.
 *
 * The row-level `canEdit(status, appealType)` gate at the click site keeps statuses without an
 * enabled matrix cell out of reach.
 */
export function pickEditModal(
  status: AppealStatus,
  appealType: AppealType | undefined
): EditModalChoice {
  if (status === AppealStatus.APPEAL_SUBMITTED && appealType === AppealType.SUBSEQUENT) {
    return 'EditAppealModal';
  }
  if (status === AppealStatus.NO_APPEAL || status === AppealStatus.DEADLINE_EXPIRED) {
    return 'MarkPartialWriteOffModal';
  }
  if (status === AppealStatus.APPEAL_APPROVED) {
    return 'MarkAppealApprovedModal';
  }
  return 'MarkToBeAppealedModal';
}
